<template>
	<div
  v-on:click="userAvatarClicked()"
  class="user-avatar-container"
  v-bind:class="{desktop: !isMobile() && !isTablet(), mobile: isMobile() || isTablet()}">
    <img
    class="icon login"
    v-if="!userIsAdmin"
    src="../../../assets/img/drawer-icon-user.svg" alt="login-icon">
    <img
    class="icon login"
      v-if="userIsAdmin"
    src="../../../assets/img/drawer-icon-user-admin.svg" alt="login-icon">
	</div>
</template>

<script>
import vueMqMixin from "../mixins/VueMqMixin";

export default {
  name: "UserAvatar",
  mixins: [vueMqMixin],
  props: {
      user: Object,
      userIsAdmin: Boolean,
      userAvatarClicked: Function
  }
};
</script>

<style lang="scss" scoped>
.user-avatar-container{
  &.desktop{
    width: 100%;

    &:hover{
      cursor: pointer;
    }

    .icon{
      left: 0;
    }
  }

  &.mobile{
    .icon{
      width: 100%;
    }
  }
}
</style>
